import {
  waitForDatastoreToBeReady
} from "./chunk-M6XBIRMD.mjs";
import {
  generate_pushid_default
} from "./chunk-QMCIPUKM.mjs";
import {
  State
} from "./chunk-UGYTHHMM.mjs";
import {
  timestamp
} from "./chunk-QBXWAUJA.mjs";

// src/events/fire-event/fire-event.ts
async function fireEvent(eventData, options) {
  const { unix, microseconds } = timestamp();
  let datastoreIsReady = false;
  if (options?.fireImmediately) {
    datastoreIsReady = true;
  } else {
    datastoreIsReady = await waitForDatastoreToBeReady();
  }
  if (datastoreIsReady && window.yvaDatastore && window.yvaDatastore.currentContextId) {
    window.yvaDatastore.events.push({
      contextId: window.yvaDatastore.currentContextId,
      data: {
        /** Allow `screenId` to be overridden, but in most cases this is not necessary. */
        screenId: State.get("templatedPathname") ?? location.pathname,
        ...eventData,
        created: unix,
        createdMicros: microseconds,
        eventId: generate_pushid_default()
      },
      lockId: null,
      status: "ready"
    });
    if (options?.callback) {
      options.callback();
    }
  }
}

export {
  fireEvent
};
